/**
 * Normalizes Qoph chats and Mental Groups into a unified format for the Chat Sidebar.
 */
export const normalizeChats = (qophChats = [], mentalGroups = []) => {
  const normalizedQoph = qophChats.map(chat => ({
    id: chat.id,
    title: chat.title || 'Qoph',
    type: 'qoph',
    manifesto: chat.manifesto,
    updatedAt: chat.updatedAt || chat.updated_at,
    avatar: 'Q', // Oracle icon
    lastMessage: chat.lastMessage || null, // Qoph list doesn't currently return lastMessage, but we reserve the field
    firstQuery: chat.firstQuery || null
  }));

  const normalizedGroups = mentalGroups
    .filter(group => group.userStatus === 'active' || group.isArchived)
    .map(group => ({
      id: group.id,
      title: group.title,
      type: 'group',
      manifesto: group.manifesto,
      updatedAt: group.updatedAt || group.updated_at || group.endDate, // Fallback to endDate if updatedAt is missing
      avatar: '◎', // Group icon
      lastMessage: group.firstQuery || null, // Using firstQuery as a hint of activity if lastMessage is not available
      isArchived: group.isArchived,
      members: group.members || []
    }));

  // Sort groups by interaction date (descending)
  normalizedGroups.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  // Combine: Pinned Qoph chats first, then sorted groups
  return [...normalizedQoph, ...normalizedGroups];
};
